import { getApprovalButtons, getInstFormDataVersion } from '@/api/flow'
import { canLock } from '@/api/process'

const CAN_LOCK_STATUS = {
  0: 'hasHandle', //0:任务已经处理
  1: 'canLock', //1:可以锁定
  2: 'NoUnlock', //2:不需要解锁
  3: 'canUnlock', //3:可以解锁
  4: 'LockedBySomeone', //4,被其他人锁定
  5: 'adminOperate', //5:这种情况一般是管理员操作
}
const state = () => ({
  approvalButtonList: [], //审批按钮
  taskStatus: '', //任务能否锁定状态
  isFromApplicationModule: false,
  formDataVersion: -1, // -1 表示未获取
})
const getters = {}

const mutations = {
  getApprovalButtonList(state, buttons) {
    state.approvalButtonList = buttons
  },
  setTaskStatus(state, payload) {
    state.taskStatus = payload
  },
  updateApplicationModule(state, payload) {
    state.isFromApplicationModule = payload
  },
  SET_FORM_DATA_VERSION(state, payload) {
    state.formDataVersion = payload
  },
}
const actions = {
  //获取审批按钮
  getApprovalButtonByTaskId({ commit }, query) {
    return new Promise((resolve) => {
      getApprovalButtons(query, (res) => {
        commit('getApprovalButtonList', res?.buttons)
        resolve(res?.buttons)
      })
    })
  },
  //获取任务是否能锁定状态
  getTaskIsLockStatus({ commit }, query) {
    canLock(query, (res) => {
      if (res) {
        commit('setTaskStatus', CAN_LOCK_STATUS[res])
      }
    })
  },
  resetApprovalButtonList({ commit }) {
    commit('getApprovalButtonList', [])
  },
  getInstFormDataVersion({ commit, dispatch }, instId, retryCount = 0) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise((resolve, reject) => {
      try {
        commit('SET_FORM_DATA_VERSION', -1) // 重置版本
        getInstFormDataVersion(instId).then(({ value }) => {
          commit('SET_FORM_DATA_VERSION', value)
          resolve(value)
        })
      } catch (e) {
        console.error('乐观锁调用错误:' + e.message)
        if (retryCount < 3) {
          // 最多重试3次
          setTimeout(() => {
            dispatch('getInstFormDataVersion', instId, retryCount + 1)
              .then(resolve)
              .catch(reject)
          }, 1000)
        } else {
          reject(e)
        }
      }
    })
  },
}
export default { state, getters, mutations, actions }
